export interface UserSignupType {
  phone: string;
  email: string;
  password: string;
  name: string;
  cep: string;
  checkCep: boolean;
  home_cep: string;
  cpfOrCnpj: string;
  birthday: string;
  gender: string;
  founded_at: string;
  company_size: string;
  subCategoryIds: string[];
  pin: string;
  allowLGPD: boolean;
  token: string;
  redirectURL: string;
  validatePinURL: string;
  homeAddressForm: boolean;
}

export const initialState = {
  phone: '',
  cep: '',
  name: '',
  email: '',
  password: '',
  cpfOrCnpj: '',
  subCategoryIds: [],
  pin: '',
  allowLGPD: false,
  token: '',
  redirectURL: '',
  validatePinURL: '',
  home_cep: '',
  checkCep: true,
  homeAddressForm: false
} as UserSignupType;
